export const formats = ['png', 'jpg', 'jpeg', 'pdf'];

export const formatsInputFile ="application/pdf, image/png, image/jpg, image/jpeg";
export const formatsRegex = new RegExp("/data:image\/(" + formats.join('|') + ");base64", "g");
export const formatsRegexByExtension = new RegExp("/\.(" + formats.join('|') + ")$", "g");
export const formatsText = formats.join(', ');

export default {
  formats,
  formatsInputFile,
  formatsRegexByExtension,
  formatsText
};
